@if (!inFilterOnlyMode) {
    <div class="bottom-section-break">
        <h4 class="display-name">Display Name
            <span>(40 characters maximum)</span>
        </h4>

        @if (effectiveState) {
            <div>
                <div class="radio-btn">
                    <input
                        id="display_as_auto"
                        name="displayNameType"
                        type="radio"
                        value="AUTO"
                        [ngModel]="effectiveState.displayNameType"
                        (ngModelChange)="this.applyDisplayNameType($event)"/>

                    <label for="display_as_auto">Auto</label>
                </div>

                <div class="radio-btn">
                    <input
                        id="display_as_configured"
                        name="displayNameType"
                        type="radio"
                        value="CONFIGURED"
                        [ngModel]="effectiveState.displayNameType"
                        (ngModelChange)="this.applyDisplayNameType($event)"/>

                    <label for="display_as_configured">As Configured</label>
                </div>

                <div class="radio-btn">
                    <input
                        id="display_as_custom"
                        name="displayNameType"
                        type="radio"
                        value="CUSTOM"
                        [ngModel]="effectiveState.displayNameType"
                        (ngModelChange)="this.applyDisplayNameType($event)"/>

                    <label for="display_as_custom">Custom</label>

                    @if (effectiveState.displayNameType === 'CUSTOM') {
                        <input
                            id="widget-display-name"
                            type="text"
                            class="formControl inline"
                            placeholder="Display Name"
                            maxlength="40"
                            autocomplete="off"
                            [ngModel]="effectiveState.customName"
                            (ngModelChange)="this.applyCustomName($event)"
                        />
                    }
                </div>
            </div>
        }
    </div>
}

@if (effectiveState) {
    <div class="bottom-section-break">
        @if (!inFilterOnlyMode) {
            <h4 class="display-name">Filters</h4>
        }

        <div class="toggle-row">
            <label class="label-text curPoint" [ngClass]="{'disabled': inFilterOnlyMode || !effectiveState.subscribedToDashboardFilters}">
                Master Widget
            </label>

            <cc-option-toggle
                id="master-widget"
                name="displayNameType"
                [disabled]="inFilterOnlyMode || !effectiveState.subscribedToDashboardFilters"
                [ngClass]="{'disabled-toggle': inFilterOnlyMode || !effectiveState.subscribedToDashboardFilters}"
                [(value)]="effectiveState.masterWidget"
                [labels]="['On', 'Off']"
                (valueChange)="applyMasterWidget($event)"
            >
            </cc-option-toggle>
        </div>

        <div class="toggle-row">
            <label [ngClass]="{'disabled': effectiveState.masterWidget}">View Filters</label>

            <cc-option-toggle
                id="dashboard-filters"
                name="subscribedToBoardFilters"
                [disabled]="effectiveState.masterWidget || isMultiClient"
                [ngClass]="{'disabled-toggle': effectiveState.masterWidget || isMultiClient}"
                [(value)]="effectiveState.subscribedToDashboardFilters"
                [labels]="['Subscribed', 'Unsubscribed']"
                (valueChange)="applyIsSubscribedToDashboardFilters($event)"
            >
            </cc-option-toggle>
        </div>

        @if (hasRealtimeUpdateOption) {
            <div class="toggle-row">
                <label>Polling</label>

                <cc-option-toggle
                    id="polling"
                    name="realtimeUpdates"
                    [(value)]="effectiveState.realtimeUpdates"
                    [labels]="['On', 'Off']"
                    (valueChange)="applyRealTimeUpdates($event)"
                >
                </cc-option-toggle>
            </div>
        }
    </div>
}

@if (widgetState?.configuredVisualizationTypes?.length && !inFilterOnlyMode) {
    <div class="bottom-section-break">
        <h4 class="display-name">Visualization Defaults</h4>

        <div class="toggle-row dropdown-row">
            @if (visualizationIconClass !== 'icon-stacked-area-chart') {
                <span class="{{visualizationIconClass}}"></span>
            }

            @if (visualizationIconClass === 'icon-stacked-area-chart') {
                <ddv-stacked-area-chart-icon class="{{visualizationIconClass}}"></ddv-stacked-area-chart-icon>
            }

            <label class="label-text">Initial Visualization</label>

            <app-dropdown
                id="initial-visualization"
                [options]="visualizationOptions"
                [(selected)]="initialVisualization"
                (selectedChange)="applyDefaultVisualizationType($event.value)"
            >
            </app-dropdown>
        </div>

        @if (slicerOptions?.length) {
            <div class="toggle-row dropdown-row">
                <span class="icon-search1"></span>

                <label class="label-text">Initial Slicer</label>

                <app-dropdown
                    id="default-slicer"
                    [options]="slicerOptions"
                    [(selected)]="initialSlicer"
                    (selectedChange)="applyDefaultSlicerForDefaultVisualization($event.value)"
                >
                </app-dropdown>
            </div>
        }

        @if (sortOptions?.length) {
            <ng-container>
                <div class="toggle-row dropdown-row">
                    <span class="icon-search1"></span>

                    <label class="label-text">Sort On</label>

                    <app-dropdown
                        id="sort-order-based-on"
                        [options]="sortOptions"
                        [(selected)]="sortOn"
                        (selectedChange)="applyDefaultSortOnForDefaultVisualization($event.value)"
                    >
                    </app-dropdown>
                </div>

                <div class="toggle-row dropdown-row">
                    <span class="icon-search1"></span>

                    <label class="label-text curPoint">Sort Direction</label>

                    <app-dropdown
                        id="sort-table-ascending-filters"
                        [options]="sortDirectionOptions"
                        [(selected)]="sortDirection"
                        (selectedChange)="applyDefaultSortDirectionForDefaultVisualization($event.value)"
                    >
                    </app-dropdown>
                </div>
            </ng-container>
        }
    </div>
}

<div class="save-cancel">
    @if (allowJumpToManageWidgets && !inFilterOnlyMode) {
        <div class="manage-widgets-link" (click)="manageWidgetClicked.emit()">
            <span class="icon-editcw"></span>

            <label>Edit Base Widget</label>
        </div>
    }

    @if (isCrosstalkGrid && canManageCrosstalk) {
        <div class="link-row" [ngClass]="{'edit-mode': !inFilterOnlyMode}">
            <a href="{{crosstalkManagementPageURL}}" target="_blank">Crosstalk Management</a>
        </div>
    }

    <button class="empty-btn" type="button" (click)="modalDialogActive.close('cancel')">
        Cancel
    </button>

    <button class="fill-btn" type="button" (click)="applyOverrides()">
        {{ inFilterOnlyMode ? 'apply' : 'save' }}
    </button>
</div>
